<template>
  <div style="height: 100%;background-color: #fbfbfb">
  <div style="height: 20px"></div>
  <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
    <div style="margin: 0 20px">
      <div style="height: 50px">
        <el-button type="primary" plain @click="bindDevice()">绑定设备</el-button>
        &nbsp;&nbsp;&nbsp;<span>员工姓名：</span>
        <el-input placeholder="输入员工姓名" v-model="searchKeyword" style="width: 250px"></el-input>
        &nbsp;&nbsp;&nbsp;<span>设备编号：</span>
        <el-input placeholder="输入设备编号" v-model="imei" style="width: 250px"></el-input>
        <el-button type="success" @click="queryDataTable">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto;">
        <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" highlight-current-row>
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column label="设备编号" min-width="130" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.devicetype !== 700">
                {{scope.row.deviceid}}
              </div>
              <div v-else>
                <el-tooltip placement="top" effect="dark">
                  <div slot="content">
                    <span style="font-size: 14px">版本号：</span>
                    <span style="font-size: 14px">{{scope.row.ver}}</span><br>
                    <span style="font-size: 14px">雷达监测结果：</span>
                    <span style="font-size: 14px" v-if="scope.row.radarstaus === 'tx'">休息</span>
                    <span style="font-size: 14px" v-if="scope.row.radarstaus === 'out'">动作</span><br>
                    <span style="font-size: 14px">雷达监测时间：</span>
                    <span style="font-size: 14px">{{scope.row.radartime}}</span><br>
                  </div>
                  <div>
                    <img style="vertical-align: sub;width: 20px;height: 20px"
                         src="../../../static/tableIcon/lie.png"
                         v-if="scope.row.radarstaus === 'tx'">
                    <img style="vertical-align: sub;width: 20px;height: 20px"
                         src="../../../static/tableIcon/walk.png"
                         v-if="scope.row.radarstaus === 'out'">
                    <span>{{scope.row.deviceid}}</span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="设备类型" min-width="95" align="center">
            <template slot-scope="scope">
              <span>{{getDeviceType(scope.row.devicetype)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备号码" min-width="100" align="center">
            <template slot-scope="scope">
              <span>{{getDevicePhone(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="自动巡查" min-width="60" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.auto_patrol === 1">开启</span>
              <span v-if="scope.row.auto_patrol === 0">关闭</span>
            </template>
          </el-table-column>
          <el-table-column label="电量" width="60" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.battery}}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="last_online" label="最后在线时间" min-width="140" align="center"></el-table-column>
          <el-table-column prop="sp_name" label="员工姓名" min-width="80" align="center"></el-table-column>
          <el-table-column prop="sys_username" label="绑定账号" min-width="60" align="center"></el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <i v-if="scope.row.devicetype === 901" title="微聊" class="el-icon-chat-dot-round" style="cursor: pointer; font-size: 18px;color: #5db713" @click="chatDeviceOpen(scope.row)"></i>
              <img v-if="scope.row.devicetype === 300 || scope.row.devicetype === 901 || scope.row.devicetype === 310 || scope.row.devicetype === 311 || scope.row.devicetype === 312 || scope.row.devicetype === 313" src="../../assets/tel/icon_replace.png"
                   title="更换设备" style="width: 14px;vertical-align: baseline;margin-right: 3px;cursor: pointer"
                   @click="openChange(scope.row)">
              <i v-if="scope.row.devicetype === 300 || scope.row.devicetype === 901 || scope.row.devicetype === 350 || scope.row.devicetype === 310 || scope.row.devicetype === 311 || scope.row.devicetype === 312 || scope.row.devicetype === 313 ||
              scope.row.devicetype === 351 || scope.row.devicetype === 352 || scope.row.devicetype === 353"
                 title="历史轨迹" style="cursor: pointer; font-size: 18px;" class="el-icon-delete-location" @click="openTrackMap(scope.row)"></i>
              <i v-if="scope.row.devicetype === 700 || scope.row.devicetype === 901 || scope.row.devicetype === 902 || scope.row.devicetype === 351 ||
                       scope.row.devicetype === 310 || scope.row.devicetype === 311 || scope.row.devicetype === 312 || scope.row.devicetype === 313 ||
                       scope.row.devicetype === 407 || scope.row.devicetype === 752 || scope.row.devicetype === 330 || scope.row.devicetype === 780"
                 style="cursor: pointer; font-size: 18px;color: blue" title="设备设置" class="el-icon-s-tools" @click="openList(scope.row)"></i>
              <i v-if="!(scope.row.devicetype === 850 || scope.row.devicetype === 852)" title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editDevice(scope.row)"></i>
              <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
        </el-pagination>
      </div>
    </div>
  </div>
  <!--  单聊  -->
  <el-dialog :visible.sync="chatOpen" v-if="chatOpen" width="1100px" :close-on-click-modal="false" center class="all-open">
    <chat-device ref="chat" v-model="chatOpen" :chatObj="chatObj"></chat-device>
  </el-dialog>
  <!--更换设备-->
  <el-dialog :visible.sync="changeDeviceShow" v-if="changeDeviceShow" width="600px" :close-on-click-modal="false" center class="all-open">
    <div class="title-top-alarm">
      <div> <span>更换设备</span> </div>
      <div class="line-title"></div>
    </div>
    <div>
      <change-device v-model="changeDeviceShow" :changeObj="changeObj" @getFatherEditDevice="getFatherEditDevice"></change-device>
    </div>
  </el-dialog>
  <!--位置信息-->
  <el-dialog :visible.sync="trackShow" v-if="trackShow" width="900px" :close-on-click-modal="true" top="10vh" class="all-open">
    <div class="title-top-alarm">
      <div><span>位置信息</span></div>
      <div class="line-title"></div>
    </div>
    <div style="height: 450px">
      <track-details v-model="trackShow" :trackDetailsObj="trackObj"></track-details>
    </div>
  </el-dialog>
  <!--绑定、编辑-->
  <el-dialog :title="addEditTitle" :visible.sync="addEditShow" v-if="addEditShow" width="600px" :show-close="true" :close-on-click-modal="false" center>
    <add-edit-device-new :addEditObj="addEditObj" v-model="addEditShow" @updateDevice="updateDevice"></add-edit-device-new>
  </el-dialog>
  <!--子机详情、通讯录设置、语音通知、FM频率设置、SOS呼叫号码...-->
  <el-dialog :title="listTitle" :visible.sync="listShow" v-if="listShow" width="850px" :show-close="true" :close-on-click-modal="false" center>
    <list-tabs v-model="listShow" :listObj="listObj"></list-tabs>
  </el-dialog>
  <!--0-SOS呼叫号码、1-跌倒设置、2-闹钟设置、3-语音设置、4-蓝牙功能、5-定位设置、6-室内定位、7录音上传、8-通讯录设置-->
  <el-dialog :visible.sync="listShow901" v-if="listShow901" width="1200" :close-on-click-modal="false" center class="all-open">
    <div class="title-top-alarm">
      <div><span>{{ listTitle }}</span></div>
      <div class="line-title"></div>
    </div>
    <list-tabs-cat v-model="listShow901" :listObj="listObj"></list-tabs-cat>
  </el-dialog>
  <!--9-电话本、10-白名单、11-发送消息、12-SOS报警电话、13-310闹钟提醒、14-311|313定时测量心率血氧、15-407 752滞留时长-->
  <el-dialog :visible.sync="listShow310" v-if="listShow310" width="850px" :close-on-click-modal="false" center class="all-open">
    <div class="title-top-alarm">
      <div><span>{{ listTitle }}</span></div>
      <div class="line-title"></div>
    </div>
    <list-tabs-watch310 v-model="listShow310" :listObj="listObj"></list-tabs-watch310>
  </el-dialog>
  <!--16-330亲情号、17-330白名单、18-330闹钟、19-330定位、20-SOS按键号码、21-780安装高度-->
  <el-dialog :visible.sync="listShowSet" v-if="listShowSet" width="650px" :close-on-click-modal="false" center class="all-open">
    <div class="title-top-alarm">
      <div><span>{{ listTitle }}</span></div>
      <div class="line-title"></div>
    </div>
    <list-tabs-set v-model="listShowSet" :listObj="listObj"></list-tabs-set>
  </el-dialog>
</div>
</template>

<script>
import {querydevicebyimei} from '../../api/device'
import {queryorgperson} from '../../api/orguser'
import chatDevice from '../../components/datamanagement/deviceComponents/chatDevice'
import changeDevice from '../datamanagement/deviceComponents/changeDevice'
import trackDetails from '../datamanagement/deviceComponents/trackDetails'
import listTabs from '../datamanagement/deviceComponents/listTabs'
import addEditDeviceNew from './components/addEditDeviceNew'
import {
  deletedevicenursing,
  querybinddevicetosysperson,
  queryserviceperson,
  unbinddevicetosysuser
} from '../../api/yanglaoyuan'
import listTabsWatch310 from '../datamanagement/deviceComponents/listTabsWatch310.vue'
import listTabsSet from '../datamanagement/deviceComponents/listTabsSet.vue'
import listTabsCat from '../datamanagement/deviceComponents/listTabsCat.vue'
export default {
  name: 'deviceStaff',
  components: {
    listTabsCat,
    listTabsSet,
    listTabsWatch310,
    chatDevice,
    changeDevice,
    trackDetails,
    listTabs,
    addEditDeviceNew},
  data () {
    return {
      // 左边
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      searchKeyword: '',
      imei: '',
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      isonline: 0, // 0常规查询 1在线查询 2离线查询
      isonlinearr: [
        {name: '全部设备', id: 0},
        {name: '在线设备', id: 1},
        {name: '离线设备', id: 2}
      ],
      orgpersons: [],
      serviceperson: [], // 员工
      // 微聊
      chatOpen: false,
      chatObj: {
        deviceRow: ''
      },
      // 更换设备
      changeDeviceShow: false,
      changeObj: {
        deviceRow: ''
      },
      // 历史轨迹
      trackShow: false,
      trackObj: {
        type: 'device',
        lng: '',
        lat: '',
        deviceRow: ''
      },
      // 设置
      listShow: false,
      listTitle: '',
      listObj: {
        deviceRow: '',
        // lisTabsCat不显示SOS/蓝牙/室内定位
        test: ''
      },
      // 901设置弹窗
      listShow901: false,
      listShow310: false,
      // 设备设置
      listShowSet: false,
      // 绑定 编辑
      addEditShow: false,
      addEditTitle: '',
      addEditObj: {
        roomArr: [], // 房间
        orgData: [], // 楼层
        orgArr: [], // 组织
        elderly: [], // 服务对象
        orgpersons: [], // 平台人员
        isBind: true,
        deviceRow: '',
        isGateway: false,
        radioType: 2 // 1、监护设备页面 - 老人绑定 2、员工设备页面 - 员工绑定
      },
      entityId: ''
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getUserTable()
  },
  methods: {
    // 绑定者（平台人员）
    getUserTable () {
      this.loading = true
      queryorgperson().then(res => {
        this.orgpersons = res.data.orgpersons
        this.addEditObj.orgpersons = res.data.orgpersons
        this.getServicePerson()
      }).catch(() => {
        this.loading = false
      })
    },
    // 员工
    getServicePerson () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        e_id: this.entityId
      }
      queryserviceperson(params, data).then(res => {
        this.serviceperson = res.data.serviceperson
        this.queryBindDevice()
      }).catch(() => {})
    },
    // 表格
    queryBindDevice () {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        did: 0,
        sp_name: this.searchKeyword,
        imei: this.imei
      }
      querybinddevicetosysperson(params, data).then(res => {
        this.loading = false
        this.totalCells = res.data.cnt
        this.tableData = res.data.device
        this.showTable = res.data.device
      }).catch(() => {
        this.loading = false
      })
    },
    queryDataTable () {
      this.currentPage = 1
      this.queryBindDevice()
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.pid > 0) {
          return row.p_phone
        } else {
          return row.h_phone
        }
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryBindDevice()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryBindDevice()
    },
    // 绑定设备
    bindDevice () {
      this.addEditTitle = '绑定设备'
      this.addEditObj.isBind = true
      this.addEditObj.deviceRow = ''
      this.addEditShow = true
    },
    // 微聊
    chatDeviceOpen (row) {
      this.chatObj.deviceRow = row
      this.chatOpen = true
    },
    // 更换设备
    openChange (row) {
      this.changeObj.deviceRow = row
      this.changeDeviceShow = true
    },
    // 历史轨迹
    openTrackMap (row) {
      this.trackObj.deviceRow = row
      let data = {
        imei: row.deviceid
      }
      querydevicebyimei(data).then(res => {
        this.trackObj.lat = res.data.device.Position.lat
        this.trackObj.lng = res.data.device.Position.lng
        this.trackShow = true
      }).catch(() => {})
      // this.trackShow = true
    },
    // 设置
    openList (row) {
      this.listTitle = '【' + row.deviceid + '】' + '设置'
      if (row.devicetype === 351 || row.devicetype === 352 || row.devicetype === 353) {
        this.listTitle = '【' + row.deviceid + '】' + '设置呼叫号码'
      }
      this.listObj.deviceRow = row
      if (row.devicetype === 901) {
        this.listShow901 = true
        this.listObj.test = false
      } else if (row.devicetype === 310 || row.devicetype === 311 || row.devicetype === 312 || row.devicetype === 313 ||
        row.devicetype === 407 || row.devicetype === 752) {
        this.listShow310 = true
      } else if (row.devicetype === 330 || row.devicetype === 780) {
        this.listShowSet = true
      } else {
        this.listShow = true
      }
    },
    // 编辑设备
    editDevice (row) {
      this.addEditTitle = '编辑设备'
      this.addEditObj.isBind = false
      this.addEditObj.deviceRow = row
      this.addEditShow = true
    },
    // 删除设备
    delDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将永久解绑该设备【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.endDelDevice(row)
      }).catch(() => {})
    },
    endDelDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将清除与此设备【' + name + '】有关的所有数据并解绑该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          did: row.id,
          orgid: row.orgid,
          sp_id: row.sp_id
        }
        deletedevicenursing(data).then(res => {
          if (row.devicetype === 850 || row.devicetype === 852) {
            let send = {
              imei: row.deviceid
            }
            unbinddevicetosysuser(send).then(res => {
              this.searchKeyword = ''
              if (this.tableData.length === 1 && this.currentPage > 1) {
                this.currentPage--
              }
              this.queryBindDevice()
              this.$notify({title: '成功', message: '删除设备成功', type: 'success', duration: 2000})
            })
          } else {
            this.searchKeyword = ''
            if (this.tableData.length === 1 && this.currentPage > 1) {
              this.currentPage--
            }
            this.queryBindDevice()
            this.$notify({title: '成功', message: '删除设备成功', type: 'success', duration: 2000})
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    updateDevice () {
      this.searchKeyword = ''
      this.queryBindDevice()
    },
    getFatherEditDevice () {
      this.currentPage = 1
      this.searchKeyword = ''
      this.queryBindDevice()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/deviceStaff.vue